import React from 'react'

class Books extends React.Component {
  render() {
    return(
      <div className="mp__books">
        <div className="wd">
            <img src="/img/il_2.png" alt="Кінокафе Gastroll'" className="mp__books__ill" />
            <div className="mp__sec__content">
              <h2>Фанат кінофільмів?<br />У нас дещо для вас є…</h2>
              <div className="mp__sec__content__texts">
                  <ul>
                    <li>Найкращі книги про українське та зарубіжне кіно </li>
                    <li>Сценарії, Мемуари</li>
                    <li>Художні твори, що були екранізовані, і за якими просто зараз знімають нові фільми</li>
                    <li>Літературну творчість відомих кінодіячів</li>
                    <li>Кіносувеніри на пам'ять</li>
                    <li>Розвиваючі книжки за мотивами улюблених мультиків для найменших читачі</li>
                  </ul>
              </div>
              <a href="/" className="mp__sec__content__button" style={{visibility: "hidden"}}>Переглянути асортимент</a>
            </div>
            <div className="mp__books__list">
              <a href="/" className="mp__books__list__item"><img src="img/books/1.jpg" alt="" /><div className="hint"><p className="author">Дж. Д. Селінджер</p><p className="name">Ловець у житі</p></div></a>
              <a href="/" className="mp__books__list__item"><img src="img/books/2.jpg" alt="" /><div className="hint"><p className="name">Дожвенко без гриму</p></div></a>
              <a href="/" className="mp__books__list__item"><img src="img/books/3.jpg" alt="" /><div className="hint"><p className="author">Д. Фоменко</p><p className="name">99 замальовок Києва</p></div></a>
              <a href="/" className="mp__books__list__item"><img src="img/books/4.jpg" alt="" /><div className="hint"><p className="author">Кузьма Скрябін</p><p className="name">Проза</p></div></a>
              <a href="/" className="mp__books__list__item"><img src="img/books/5.jpg" alt="" /><div className="hint"><p className="author">Андрій Кокотюха</p><p className="name">Червоний</p></div></a>
              <a href="/" className="mp__books__list__item"><img src="img/books/6.jpg" alt="" /><div className="hint"><p className="author">Маркус Зузак</p><p className="name">Крадійка книжок</p></div></a>
            </div>
            <div className="mp__books__mobbutton__wrapper mobonly">
              <a href="/" className="mp__sec__content__button mobonly" style={{visibility: "hidden"}}>Переглянути асортимент</a>
            </div>
        </div>
      </div>
    )
  }
}

export default Books


// WEBPACK FOOTER //
// ./src/components/pages/HomePage/books.jsx